   import React from 'react';
   import { Link, useLocation } from 'react-router-dom';

   const Navbar = () => {
     const location = useLocation();

     const isActive = (path) => {
       return location.pathname === path;
     };

     return (
       <nav style={{
         display: 'flex', 
         justifyContent: 'space-between', 
         alignItems: 'center', 
         padding: '1rem', 
         backgroundColor: 'white', 
         borderBottom: '1px solid #e5e7eb'
       }}>
         <Link to="/" style={{fontSize: '1.5rem', fontWeight: 'bold', color: '#10B981', textDecoration: 'none'}}>LifeStory</Link>
         <div style={{display: 'flex', gap: '2rem'}}>
           {['CANVAS', 'STORIES', 'JOURNAL', 'PROFILE'].map((item) => (
             <Link
               key={item}
               to={`/${item.toLowerCase()}`}
               style={{
                 fontSize: '0.875rem',
                 fontWeight: '500',
                 color: isActive(`/${item.toLowerCase()}`) ? '#10B981' : '#4B5563',
                 textDecoration: 'none',
                 borderBottom: isActive(`/${item.toLowerCase()}`) ? '2px solid #10B981' : 'none',
                 paddingBottom: '3px'
               }}
             >
               {item}
             </Link>
           ))}
         </div>
       </nav>
     );
   };

   export default Navbar;